var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyStack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75001 3.43586e-07C2.51786 -0.000191985 2.29287 0.080385 2.11363 0.227915C1.93438 0.375446 1.81204 0.580739 1.76759 0.808594L0.017589 9.80859C0.00559788 9.87168 -0.000288687 9.93578 1.08813e-05 10V16C1.08813e-05 17.0931 0.906948 18 2.00001 18H16C17.0931 18 18 17.0931 18 16V10C18.0003 9.93578 17.9944 9.87168 17.9824 9.80859L16.2324 0.808594C16.188 0.580739 16.0656 0.375446 15.8864 0.227915C15.7071 0.080385 15.4822 -0.000192008 15.25 3.43586e-07H2.75001ZM3.57423 2H14.4258L15.9805 10H13C12.57 10 12.1878 10.2746 12.0508 10.6836L11.4551 12.4727C11.3501 12.7867 11.0547 13 10.7227 13H7.27735C6.94535 13 6.64993 12.7877 6.54493 12.4727L5.94728 10.6836C5.81128 10.2756 5.43001 10 5.00001 10H2.01954L3.57423 2Z",
    fill: "black",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStack);
export default __webpack_public_path__ + "static/media/empty-stack.7e933cf8be6a3622aabdd8522c91cf7c.svg";
export { ForwardRef as ReactComponent };